var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outsidewx",style:({'background-color': _vm.bgColor})},[_c('OutsidePage'),_c('DownloadWx')],1)}
var staticRenderFns = []

export { render, staticRenderFns }